import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DxChartComponent } from 'devextreme-angular';
import { FileExportService } from 'src/app/common/file-export-service';
import { GlobalConstants } from 'src/app/common/global-constants';
import { HtmlControlType } from 'src/app/enums/htmlControlType';
import { BookmarkData } from 'src/app/models/Bookmark';
import { FiltersOutput, FilterInput, FilterOutput, ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { ForecastAlterGroupValue, ForecastChartCaption, ForecastDeepDiveMultiPram, ForecastOverviewPram, SettingValue } from 'src/app/models/forecast/fc-overview-models';

import { ShareDataService } from 'src/app/services/share-data.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DevTooltipCustComponent, DropdowndSelectedValues } from 'src/app/widgets';
import { HelpService } from '../../help/help.service';
import { TaskDataFilter } from '../../stock/stock.service';
import { TaskService } from '../../task/task.service';
import { ForecastService } from '../forecast.service';
import { ElementNames, ForecastElementUpdateMultiData } from 'src/app/models/forecast/fc-deepdive-models';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import { NextPreValue } from 'src/app/models/forecast/NextPrevious';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

import { SettingsService } from '../../settings/settings.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CanDeactivateService } from 'src/app/models/UnsavedData/UnsavedData';

@Component({
	selector: 'app-deep-dive-multi',
	templateUrl: './deep-dive-multi.component.html',
	styleUrls: ['./deep-dive-multi.component.scss'],
	standalone: false
})
export class DeepDiveMultiComponent implements OnInit {
	defaultValues = {
		actualCleanDeepDive: null,
		actualCleanDeepDiveLLY: null,
		actualCleanDeepDiveLY: null,
		actualDeepDive: null,
		actualDeepDiveLLY: null,
		actualDeepDiveLY: null,
		addOn1: null,
		addOn2: null,
		addOn3: null,
		addOn4: null,
		addOn5: null,
		basic1: 0,
		basic2: null,
		basic3: null,
		commercialObjectId: -1,
		elemntComment: null,
		entryUser: null,
		forecastKeyFigure1: null,
		forecastKeyFigure2: null,
		forecastKeyFigure3: null,
		forecastKeyFigure4: null,
		forecastKeyFigure5: null,
		forecastKeyFigure6: null,
		forecastKeyFigure7: null,
		forecastKeyFigure8: null,
		forecastKeyFigure9: null,
		forecastKeyFigure10: null,
		forecastObjectId: null,
		period: null,
	};
	forecastElementBasicDataCopy: any = [];
	currentlySelectedFilters: FilterInput[] = [];
	nxtPreFilterOptions: FiltersOutput;
	//Default data settings
	//Filter Variable initialization
	filterOptions: FiltersOutput;
	filterList: FilterInput[] = [];
	htmlControlType = HtmlControlType;
	resetFiltersItems: string[] = [];
	settingGroupId = 89;
	//chart value range
	visualRange: any = {};
	Action = 'Data';
	changingValue: Subject<boolean> = new Subject();
	//default data initialization
	forecastDevelopmentChartSource: any = [];
	yearOnYearChartDataSource: any = [];
	seasonalityChartDataSource: any = [];

	dataFilter: BookmarkData;
	pageName: string = 'ForecastDeepDiveMulti';
	taskFilterData: TaskDataFilter[];
	IsTaskLoad = false;
	lastSelectedFilter: FilterInput;
	forecastChartCaption: ForecastChartCaption[];
	titleOverviewTitle = 'Monthly';
	settingValueData: SettingValue[] = [];
	//Forecast Seasonality Grph enable disable contain
	EnableDisableForecastSeasonalityActual1 = true;
	EnableDisableForecastSeasonalityActual2 = true;
	EnableDisableForecastSeasonalityActual3 = true;
	EnableDisableForecastSeasonalityForecastFinal3 = true;
	EnableDisableForecastSeasonalityMin = true;
	EnableDisableForecastSeasonalityMax = true;
	alterGroupData: ForecastAlterGroupValue[] = [];

	alterGroupTitle = '';
	startChartValue = { startValue: 0 };
	FinalForecast1Caption = 'Perito Forecast';
	FinalForecast3Caption = 'Forecast Final';
	DisplayMinRoundingPlacesFc = 4;
	DisplayMinRoundingBelowNumberFc = 10;

	public activePageIndex: number = 0;
	public pageSize: number = 5;

	tableSettings = [];

	dataLoadInstantly = 1;

	public dataFullyLoaded = false;

	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild('forecastDevelopmentChart', { static: false }) dxForecastDevelopmentChart: DxChartComponent;
	@ViewChild('seasonalityChart', { static: false }) dxSeasonalityChart: DxChartComponent;
	@ViewChild('yearOnYearChart', { static: false }) dxYearOnYearChart: DxChartComponent;
	// @ViewChild("forecastDevelopmentRangSelct", { static: false }) forecastDevelopmentRangSelct: DxRangeSelectorComponent;
	@ViewChild('container', { static: false }) container: ElementRef;

	constructor(
		private taskService: TaskService,
		private forecastService: ForecastService,
		private titleService: Title,
		private helpService: HelpService,
		private shareDataService: ShareDataService,
		private authService: AuthService,
		private fileExportService: FileExportService,
		private settingsService: SettingsService,
		private readonly notificationService: NotificationService,
		private readonly activeService: CanDeactivateService
	) {
		this.shareDataService.CleanData();
	}

	removalFunction: () => {};

	ngOnInit() {
		this.settingsService.getGeneralSettings().subscribe((res) => {
			this.tableSettings = res.settings.filter((x) => x.name === 'ESO Deep Dive Multi paging style');
			this.tableSettings[0].value = +this.tableSettings[0].value;

			this.dataLoadInstantly = +res.settings.find((x) => x.name === 'ESO Deep Dive Multi wait for filter').value;

			this.WindowHeight = window.innerHeight - 150 + 'px';
			this.titleService.setTitle('Forecast Deep Dive Multi');

			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = 0;
			this.dataFilter.name = 'DefBokmk';
			this.dataFilter.pageName = this.pageName;
			this.WebSettingsPivot();
		});
	}

	TableScrollWidth = 500;

	onResize(action: string) { }

	pageChanged(evt) {
		this.activePageIndex = evt;
	}

	loadBookMarkFilterClick(data) {

		if (!this.onNextPrevConfirm()) {
			return;
		}

		if (data != null && data != undefined && data.bookmarkId != null && data.bookmarkId != undefined) {
			this.filterOptions.filters = [];
			this.clearSelectedItem();
			this.filterList.map((item) => (item.selectedValues = []));
			this.resetFiltersItems = [];
			this.currentlySelectedFilters = [];

			this.dataFilter = new BookmarkData();
			this.dataFilter.BookmarkId = data.bookmarkId;
			this.dataFilter.name = 'Bokmk';
			this.dataFilter.pageName = this.pageName;
			this.loadBookMarkFilter();
		}
	}

	HideNegativePopup() {
		this.proceedingInfoPopup = false;
	}

	ChartSettings: any;
	loadBookMarkFilter() {
		let filterData = Object.assign({}, this.dataFilter);
		filterData.name = 'BokmkN';
		this.ChartSettings = null;
		this.ForecatObjectTable = [];
		this.ForecatUnChnageObjectTable = [];
		this.taskService.LoadBookmarkData(filterData).subscribe(
			(RData) => {
				if (RData != null && RData.table != null && RData.table.length > 0) {

					if (RData.table[0].chartSettings != null && RData.table[0].chartSettings != '') {

						this.ChartSettings = JSON.parse(RData.table[0].chartSettings);
					}
					this.taskService.LoadBookmarkFilter(this.dataFilter).subscribe(
						(data) => {
							this.taskFilterData = data;
							//default load with parameters
							this.filterOptions = new FiltersOutput();
							this.filterOptions.action = this.Action;
							this.filterOptions.settingGroupId = this.settingGroupId;
							this.filterOptions.filters = [];
							this.taskFilterData.forEach((element) => {
								let filteItem: FilterOutput = new FilterOutput();
								filteItem.fieldValue = element.settingValue;
								filteItem.settingId = element.settingId;
								this.filterOptions.filters.push(filteItem);
							});

							this.IsTaskLoad = true;
							this.fillSharedItem();

							this.getFiltersData();
							if (this.dataLoadInstantly === 2 || this.filterOptions.filters.length !== 0) {
								this.getData('pageload');
							}
						},
						(err) => { }
					);
				} else {

					this.initFilterOptions();
				}
			},
			(err) => { }
		);
	}

	LoadChartSeries() {
		if (this.ChartSettings != null) {
			if (this.ChartSettings.ForecastDevelopmentChart != null && this.ChartSettings.ForecastDevelopmentChart.length > 0) {
				if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null && Array.isArray(this.dxForecastDevelopmentChart.series) &&
					this.dxForecastDevelopmentChart.series.length > 0) {
					for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
						this.ChartSettings.ForecastDevelopmentChart.forEach((itemchrt) => {
							if (this.dxForecastDevelopmentChart.series[index].valueField != null && itemchrt.isVisible != null && (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase() || this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())) {
								this.dxForecastDevelopmentChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.YearOnYearChart != null && this.ChartSettings.YearOnYearChart.length > 0) {
				if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null && Array.isArray(this.dxYearOnYearChart.series) &&
					this.dxYearOnYearChart.series.length > 0) {
					for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
						this.ChartSettings.YearOnYearChart.forEach((itemchrt) => {
							if (this.dxYearOnYearChart.series[index].valueField != null && itemchrt.isVisible != null && (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase() || this.dxYearOnYearChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())) {
								this.dxYearOnYearChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.SeasonalityChart != null && this.ChartSettings.SeasonalityChart.length > 0) {
				if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null && Array.isArray(this.dxSeasonalityChart.series) &&
					this.dxSeasonalityChart.series.length > 0) {
					for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
						this.ChartSettings.SeasonalityChart.forEach((itemchrt) => {
							if (this.dxSeasonalityChart.series[index].valueField != null && itemchrt.isVisible != null && (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase() || this.dxSeasonalityChart.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())) {
								this.dxSeasonalityChart.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}
		}
	}

	processChartChanges() {
		let $this = this;
		this.WindowHeight = window.innerHeight - 150 + 'px';
		if (this.container != null) {
			this.TableScrollWidth = (this.container.nativeElement as HTMLElement).offsetWidth;
		}

		if ($this.dxForecastDevelopmentChart != null && $this.dxForecastDevelopmentChart.instance != null) {
			$this.dxForecastDevelopmentChart.instance.refresh();
		}
		if ($this.dxSeasonalityChart != null && $this.dxSeasonalityChart.instance != null) {
			$this.dxSeasonalityChart.instance.refresh();
		}
		if ($this.dxYearOnYearChart != null && $this.dxYearOnYearChart.instance != null) {
			$this.dxYearOnYearChart.instance.refresh();
		}

		if ($this.container != null) {
			$this.TableScrollWidth = ($this.container.nativeElement as HTMLElement).offsetWidth;
			//console.log(this.TableScrollWidth,"this.TableScrollWidththis.TableScrollWidththis.TableScrollWidththis.TableScrollWidththis.TableScrollWidththis.TableScrollWidththis.TableScrollWidth")
		}
	}

	loadLengendToShare() {
		let seriesValues = { ForecastDevelopmentChart: [], YearOnYearChart: [], SeasonalityChart: [], ScopeList: [] };
		if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.instance != null && this.dxForecastDevelopmentChart.instance.getAllSeries() != null) {
			this.dxForecastDevelopmentChart.instance.getAllSeries().forEach((item) => {
				if (item.name != null && item['getValueFields']() && item['getValueFields']().length > 0) {
					seriesValues.ForecastDevelopmentChart.push({ ValueField: item['getValueFields']()[0], Name: item.name, isVisible: item.isVisible() });
				}
			});
		}

		if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.instance != null && this.dxYearOnYearChart.instance.getAllSeries() != null) {
			this.dxYearOnYearChart.instance.getAllSeries().forEach((item) => {
				if (item.name != null && item['getValueFields']() && item['getValueFields']().length > 0) {
					seriesValues.YearOnYearChart.push({ ValueField: item['getValueFields']()[0], Name: item.name, isVisible: item.isVisible() });
				}
			});
		}

		if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.instance != null && this.dxSeasonalityChart.instance.getAllSeries() != null) {
			this.dxSeasonalityChart.instance.getAllSeries().forEach((item) => {
				if (item.name != null && item['getValueFields']() && item['getValueFields']().length > 0) {
					seriesValues.SeasonalityChart.push({ ValueField: item['getValueFields']()[0], Name: item.name, isVisible: item.isVisible() });
				}
			});
		}
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	//hide and show series on click
	onLegendClick(e: any) {
		const series = e.target;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}
	//#endregion

	clearSelectedItem() { }

	//load filter data method
	ExportToExcelFilters: ExportFilter[] = [];
	filterMappingService = new FilterMappingService();
	IsFilterLoadedComplt = false;
	private getFiltersData() {
		let $this = this;
		this.ExportToExcelFilters = this.filterMappingService.mapFilterOutputToFilterValue(this.filterOptions.filters);
		this.forecastService.SelectForecastDeepDiveMultiFilters(this.settingGroupId, this.filterOptions.filters).subscribe(
			(res) => {
				//convert received data to table structure for drop down
				res.forEach((item) => {
					if (item.values) {
						item.values = item.values.map((all) => ({ all }));

					}
				});
				$this.filterList = res.filter((item) => item.isVisible);

				for (let index = 0; index < this.filterList.length; index++) {
					if (this.filterList[index]) {
						let data = this.currentlySelectedFilters.filter((x) => x.selectionId == this.filterList[index].selectionId);
						if (data && data.length > 0) {
							this.filterList[index].selectedValues = data[0].selectedValues;
							this.lastSelectedFilter = null;
						}
					}
				}

				if (this.IsTaskLoad) {
					this.IsTaskLoad = false;
					$this.filterList.forEach((element) => {
						let Data = $this.taskFilterData.filter((x) => x.settingId == element.selectionId);
						if (Data != null && Data.length > 0) {
							let arr = Data.map(function (item) {
								return item['settingValue'];
							});
							element.selectedValues = arr;
						}
					});
				}
				this.IsTaskLoad = false;
				this.IsFilterLoadedComplt = true;
			},
			(err) => {
				console.log(err);
				this.notificationService.error(err);
				this.IsTaskLoad = false;
				this.IsFilterLoadedComplt = true;
			},
			() => {
				//loading data method
				// this.getData();
			}
		);
	}

	private initFilterOptions() {
		//default load with parameters
		this.filterOptions = new FiltersOutput();
		this.filterOptions.action = this.Action;
		this.filterOptions.settingGroupId = this.settingGroupId;
		this.filterOptions.filters = [];
		//loading filter data

		this.getFiltersData();
		if (this.dataLoadInstantly === 2 || this.filterOptions.filters.length !== 0) {
			this.getData('pageload');
		}
	}

	selectedItemsChanged(event: DropdowndSelectedValues) {
		this.filterList.filter((item) => item.selectionId === event.selectionId).forEach((item) => (item.selectedValues = event.values));

		this.lastSelectedFilter = this.filterList.filter((item) => item.selectionId === event.selectionId)[0];
	}
	setTextBoxFilterOptions(settingId: any, event: any) { }

	dataCountTable = 0;
	requestDataCountFromServer(action = 'reload') {

		if (!this.onNextPrevConfirm()) {
			return;
		}

		if (this.currentValueNxtPr != null && this.currentValueNxtPr.columnName != null) {
			this.OnResetPreDieldChange(this.currentValueNxtPr.columnName);
		}
		if (this.changingValue != null) {
			this.changingValue.next(true);
		}
		this.currentValueNxtPr = null;
		this.StopScrolling = false;
		this.IsInfinitScrollDisabled = true;
		this.PageNo = 1;
		this.ForecatObjectTable = [];
		this.ForecatUnChnageObjectTable = [];
		this.clearSelectedItem();

		let currentFilters: FilterInput[] = [];
		let filters: FilterOutput[] = [];
		this.taskFilterData = [];
		//finding each data and pushing to this.filterOptions.filters variable
		if (this.filterList.filter((item) => item.selectedValues).length > 0) {
			this.filterList.forEach((item) => {
				if (item.selectedValues && item.selectedValues.length > 0) {
					const current = new FilterInput();
					current.selectionId = item.selectionId;
					current.selectedValues = item.selectedValues;
					currentFilters.push(current);

					item.selectedValues.forEach((el) => {
						let f = new FilterOutput();
						f.settingId = item.selectionId;
						f.fieldValue = el;
						let taskF = new TaskDataFilter();
						taskF.settingId = item.selectionId;
						taskF.settingValue = el;
						this.taskFilterData.push(taskF);
						filters.push(f);
					});
				}
			});
		}
		this.currentlySelectedFilters = currentFilters;

		this.filterOptions.filters = filters;
		this.shareDataService.CleanData();

		if (this.StopScrolling) {
			AppDevNotifyComponent.SuccesMessage('You have reach end of search. ');

		} else {
			let dataObjectPram: ForecastDeepDiveMultiPram = new ForecastDeepDiveMultiPram();
			dataObjectPram.Action = action;
			dataObjectPram.PageNumber = this.PageNo;
			dataObjectPram.RowsOfPage = this.PageSize;
			dataObjectPram.filtersOptions = [];
			dataObjectPram.MultipleFactor = this.MultipleFactor;



			if (action == 'loadNextPreOption') {

				if (this.nxtPreFilterOptions != null && this.nxtPreFilterOptions.filters != null && this.nxtPreFilterOptions.filters.length > 0) {
					this.nxtPreFilterOptions.filters.forEach((selElemnt) => {
						dataObjectPram.filtersOptions.push({
							settingId: selElemnt.settingId,
							fieldValue: selElemnt.fieldValue,
						});
					});
				}
			} else {
				this.filterOptions.filters.forEach((element) => {
					dataObjectPram.filtersOptions.push(element);
				});
			}
			dataObjectPram.OrderField = 0;
			dataObjectPram.OrderSeq = 1;
			if (this.ForecatCaptionTable && this.ForecatCaptionTable.length > 0 && this.ForecatCaptionTable.find((x) => x.Ordering == 1) != null) {
				let sitem = this.ForecatCaptionTable.find((x) => x.Ordering == 1);
				dataObjectPram.OrderField = sitem.orderBy + 1;
				dataObjectPram.OrderSeq = sitem.AscDsend;
			}

			this.forecastService
				.SelectForecastDeepDiveTableMultiDataCount(dataObjectPram)
				.toPromise()
				.then((data) => {
					this.dataCountTable = data;

					if (this.dataCountTable > 500) {
						this.tooManyObjectsPopupVisible = true;
					} else {
						this.applyFilters();
					}
				})
				.catch((err) => {
					console.log(err, 'test error');
					this.IsInfinitScrollDisabled = false;

				});
		}
	}

	applyFilters() {


		this.fillSharedItem();
		this.loadLengendToShare();
		this.getFiltersData();
		this.getData('pageload');
	}

	fillSharedItem() {
		this.shareDataService.filterOptions = this.filterOptions;
	}
	//load data on each event
	isFirstDataLoad = false;
	private getData(action: string) {


		this.loadGraphData(action);
		this.loadTableData(action);
	}

	loadGraphData(action: string) {
		if (this.EnableGraph) {
			let dataObjectPram: ForecastOverviewPram = new ForecastOverviewPram();
			dataObjectPram.Action = this.Action;
			dataObjectPram.Unit = '';
			dataObjectPram.SettingGroupId = this.settingGroupId;
			dataObjectPram.UnitOfMeasure = '';

			if (this.dxForecastDevelopmentChart) {
				this.dxForecastDevelopmentChart.instance.showLoadingIndicator();
			}
			if (this.dxSeasonalityChart) {
				this.dxSeasonalityChart.instance.showLoadingIndicator();
			}
			if (this.dxYearOnYearChart) {
				this.dxYearOnYearChart.instance.showLoadingIndicator();
			}

			if (action == 'loadNextPreOption') {
				if (this.nxtPreFilterOptions != null && this.nxtPreFilterOptions.filters != null && this.nxtPreFilterOptions.filters.length > 0) {
					this.nxtPreFilterOptions.filters.forEach((selElemnt) => {
						dataObjectPram.filtersOptions.push({
							settingId: selElemnt.settingId,
							fieldValue: selElemnt.fieldValue,
						});
					});
				}

			} else {
				this.filterOptions.filters.forEach((element) => {
					dataObjectPram.filtersOptions.push(element);
				});
			}

			this.forecastService
				.GetForecastDeepDiveMulti(dataObjectPram)
				.toPromise()
				.then((data) => {
					if (data != null && data.forecastChartCaption != null && data.forecastChartCaption.length > 0) {
						this.forecastChartCaption = data.forecastChartCaption;
						data.forecastChartCaption.forEach((itemCap) => {
							if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null && Array.isArray(this.dxForecastDevelopmentChart.series) &&
								this.dxForecastDevelopmentChart.series.length > 0) {
								for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
									if (this.dxForecastDevelopmentChart.series[index].valueField != null && (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase() || this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())) {
										this.dxForecastDevelopmentChart.series[index].name = itemCap.captionName;
									}

									if (itemCap.fieldName.toLowerCase() == 'finalforecast1' && itemCap.captionName.toLowerCase() != '') {
										this.FinalForecast1Caption = itemCap.captionName;
									}
									if (itemCap.fieldName.toLowerCase() == 'finalforecast3' && itemCap.captionName.toLowerCase() != '') {
										this.FinalForecast3Caption = itemCap.captionName;
									}
								}
							}

							if (this.dxSeasonalityChart != null && this.dxSeasonalityChart.series != null && Array.isArray(this.dxSeasonalityChart.series) &&
								this.dxSeasonalityChart.series.length > 0) {
								for (let index = 0; index < this.dxSeasonalityChart.series.length; index++) {
									if (this.dxSeasonalityChart.series[index].valueField != null && (this.dxSeasonalityChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase() || this.dxSeasonalityChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())) {


										this.dxSeasonalityChart.series[index].name = itemCap.captionName;
									}
									this.dxSeasonalityChart.series[index].visible = true;
								}
							}

							if (this.dxYearOnYearChart != null && this.dxYearOnYearChart.series != null && Array.isArray(this.dxYearOnYearChart.series) &&
								this.dxYearOnYearChart.series.length > 0) {
								for (let index = 0; index < this.dxYearOnYearChart.series.length; index++) {
									if (this.dxYearOnYearChart.series[index].valueField != null && (this.dxYearOnYearChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase() || this.dxYearOnYearChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())) {

										this.dxYearOnYearChart.series[index].name = itemCap.captionName;
									}
									this.dxYearOnYearChart.series[index].visible = true;
								}
							}

							if (itemCap.fieldName.toLowerCase() == 'forecastoverviewcharttitle') {
								this.titleOverviewTitle = itemCap.captionName;
							}
						});
					}

					//dynamic feild setting
					let VisibleElements = [];
					if (data != null && data.settingValue != null && data.settingValue.length > 0) {
						data.settingValue.forEach((settingItem) => {
							if (settingItem.name.toLowerCase().includes('enabledisable')) {
								let ElementNameEnable = settingItem.name.toLowerCase();
								ElementNameEnable = ElementNameEnable.replace('enabledisable', '');
								if (settingItem.value.toLowerCase() == 'no') {
									VisibleElements.push({ visible: false, showInLegend: true, SeriesName: ElementNameEnable });
								}
							}
							if (settingItem.name.toLowerCase().includes('enable')) {
								let ElementName = settingItem.name.toLowerCase();
								ElementName = ElementName.replace('forecastmainchart', '').replace('enable', '');
								if (settingItem.value.toLowerCase() == 'yes') {
									VisibleElements.push({ visible: true, showInLegend: true, SeriesName: ElementName });
								} else if (settingItem.value.toLowerCase() == 'no') {
									VisibleElements.push({ visible: false, showInLegend: false, SeriesName: ElementName });
								}
							}
						});
					}

					if (Array.isArray(this.dxForecastDevelopmentChart.series)) {
						for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
							//emable/disbale
							if (this.dxForecastDevelopmentChart.series[index].valueField != null) {
								let ElemntExists = VisibleElements.filter((x) => x.SeriesName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase());

								if (ElemntExists != null && ElemntExists.length > 0) {
									if (ElemntExists.length > 1) {
										if (!ElemntExists[0].visible || !ElemntExists[1].visible) {
											this.dxForecastDevelopmentChart.series[index].visible = false;
										} else {
											this.dxForecastDevelopmentChart.series[index].visible = true;
										}

										if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend) {
											this.dxForecastDevelopmentChart.series[index].showInLegend = false;
										} else {
											this.dxForecastDevelopmentChart.series[index].showInLegend = true;
										}
									} else {
										this.dxForecastDevelopmentChart.series[index].visible = ElemntExists[0].visible;
										this.dxForecastDevelopmentChart.series[index].showInLegend = ElemntExists[0].showInLegend;
									}
								} else {
									if (
										!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes('addon') &&
										!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes('actual1') &&
										!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes('actual2') &&
										!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes('actual3')
									) {
										this.dxForecastDevelopmentChart.series[index].visible = true;
										this.dxForecastDevelopmentChart.series[index].showInLegend = true;
									}
								}
							}

							if (data != null && data.settingValue != null && data.settingValue.length > 0) {
								data.settingValue.forEach((settingItem) => {
									if (settingItem.name.toLowerCase().includes('color')) {
										let ElementName = settingItem.name.toLowerCase();
										ElementName = ElementName.replace('color', '');
										if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != '') {
											this.dxForecastDevelopmentChart.series[index].color = settingItem.value;
										}
									}
									if (settingItem.name.toLowerCase().includes('charttype')) {
										let ElementName = settingItem.name.toLowerCase();
										ElementName = ElementName.replace('charttype', '');
										if (ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() && settingItem.value != null && settingItem.value != '') {
											let chartTypes = settingItem.value.split('-');
											if (chartTypes.length > 0) {
												this.dxForecastDevelopmentChart.series[index].type = chartTypes[0];
											}
											if (chartTypes.length > 1) {
												this.dxForecastDevelopmentChart.series[index].dashStyle = chartTypes[1];
											}
										}
									}
								});
							}
						}
					}
					this.settingValueData = data.settingValue;
					if (data != null && data.settingValue != null && data.settingValue.length > 0) {
						data.settingValue.forEach((settingItem) => {
							if (settingItem.name == 'ForecastOverviewAltPeriodChartHeader' && settingItem.value != null) {
								this.alterGroupTitle = settingItem.value;
							}

							//EnableNegativeForecast
							if (settingItem.name == 'EnableNegativeForecast' && settingItem.value && settingItem.value == 'yes') {
								this.startChartValue = null;
							}

							//Enable Disable Forecast Seasonality
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalityactual1')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityActual1 = false;
								}
							}
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalityactual2')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityActual2 = false;
								}
							}
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalityactual3')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityActual3 = false;
								}
							}
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalityforecastfinal3')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityForecastFinal3 = false;
								}
							}
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalitymin')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityMin = false;
								}
							}
							if (settingItem.name.toLowerCase().includes('enabledisableforecastseasonalitymax')) {
								if (settingItem.value.toLowerCase() == 'no') {
									this.EnableDisableForecastSeasonalityMax = false;
								}
							}
						});
					}

					if (data) {
						this.forecastDevelopmentChartSource = data.forecastDevelopmentChart;
						this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();

						this.seasonalityChartDataSource = data.forecastSeasonalityChartPers;
						this.dxSeasonalityChart.instance.hideLoadingIndicator();
						this.yearOnYearChartDataSource = data.forecastYearOnYearChart;


						//adding for year on year chart data need to be serials
						if (data.forecastYearOnYearChart != null) {
							data.forecastYearOnYearChart.forEach((EachItem) => {
								if (EachItem != null) {
									this.yearOnYearChartDataSource.push({ DataName: 'RXY', DataValue: EachItem.rxy });
									this.yearOnYearChartDataSource.push({ DataName: 'FinalForecast3', DataValue: EachItem.finalForecast3 });
									this.yearOnYearChartDataSource.push({ DataName: 'ReleasedForecast', DataValue: EachItem.releasedForecast });
									this.yearOnYearChartDataSource.push({ DataName: 'Actual', DataValue: EachItem.actual });
								}
							});

							this.dxYearOnYearChart.instance.hideLoadingIndicator();
						}
					} else {
						//setting data to null if no data found
						this.forecastDevelopmentChartSource = [];
						this.yearOnYearChartDataSource = [];
						this.seasonalityChartDataSource = [];

						this.dxForecastDevelopmentChart.instance.hideLoadingIndicator();
						this.dxSeasonalityChart.instance.hideLoadingIndicator();
						this.dxYearOnYearChart.instance.hideLoadingIndicator();
					}

					this.LoadChartSeries();
					this.processChartChanges();
				})
				.catch((err) => {
					console.log(err, 'test error');
				});
		}
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();

		}
		this.loadLengendToShare();
	}

	//#region Chart Settings and funcation
	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		if (info && info.originalValue && this.DisplayMinRoundingBelowNumberFc > info.originalValue) {

			return DevTooltipCustComponent.customizeTooltip(info, 'Year-Month', '', '', true, this.DisplayMinRoundingPlacesFc);
		}
		return DevTooltipCustComponent.customizeTooltip(info, 'Year-Month', '', '');
	};

	//adding customize setting with title, change title if need.
	customizeTooltipFc = (info: any) => {
		if (info && info.originalValue && this.DisplayMinRoundingBelowNumberFc > info.originalValue) {

			return DevTooltipCustComponent.customizeTooltipNew(info, '', '', '', true, this.DisplayMinRoundingPlacesFc);
		}
		return DevTooltipCustComponent.customizeTooltipNew(info, '', '', '');
	};

	customizeValuesAxis = (info: any) => {
		let values = 0;
		if (!isNaN(info.value)) {
			values = Number(info.value);
		}
		if (this.DisplayMinRoundingBelowNumberFc > values) {
			return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.DisplayMinRoundingPlacesFc);
		}
		return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.RoundOffNumber);

	};

	//adding percentage symbol in seasonality
	customizeText = (info: any) => {
		return Math.round(info.value).toLocaleString() + '%';
	};

	//adding customize Point color for seasonality chart only
	customizePoint = (arg: any) => {
		if (arg.argument != null) {
			if (arg.argument == 'FC') {
				return {
					visible: true,
					color: '#BE4B48',
				};
			}
		}

		return undefined;
	};

	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

	//reseting filter data
	resetFilters() {

		if (!this.onNextPrevConfirm()) {
			return;
		}

		// Resetting the current value for next/previous
		if (this.currentValueNxtPr != null && this.currentValueNxtPr.columnName != null) {
			this.OnResetPreDieldChange(this.currentValueNxtPr.columnName);
		}
		if (this.changingValue != null) {
			this.changingValue.next(true);
		}
		this.currentValueNxtPr = null;
		this.ForecatObjectTableCopy = [];

		document.querySelectorAll('.input-number').forEach((x) => {
			x.removeEventListener('input', this.removalFunction, true);
		});

		if (this.ForecatCaptionTable != null && this.ForecatCaptionTable.length > 0) {
			this.ForecatCaptionTable.forEach((item) => {
				item.Ordering = 0;
				item.AscDsend = 1;
			});
		}
		this.taskFilterData = [];
		this.PageNo = 1;
		this.StopScrolling = false;
		this.ChartSettings = null;
		this.changingValue.next(true);
		// this.loadLengendToShare();
		this.filterOptions.filters = [];
		this.clearSelectedItem();
		this.filterList.map((item) => (item.selectedValues = []));
		this.IsTaskLoad = false;

		this.ForecatUnChnageObjectTable = [];
		this.ForecatObjectTable = [];

		this.resetFiltersItems = [];
		this.currentlySelectedFilters = [];
		//this.WebSettingsPivot();
		this.dataFullyLoaded = false;
		this.forecastDevelopmentChartSource = [];
		this.yearOnYearChartDataSource = [];
		this.seasonalityChartDataSource = [];
		this.shareDataService.CleanData();
		//this.fillSharedItem();
		//this.loadLengendToShare();
		this.getFiltersData();
		//this.requestDataCountFromServer('reload');
	}

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	IsExportEnable = false;
	EnableBasicFcDeepDive = true;
	enableNextPrevious = false;

	WebSettingsPivot() {
		this.fileExportService.WebSettingsPivot('ForecastDeepDiveMultiSettings').subscribe(
			(result) => {
				if (result != null && result.length > 0 && result[0].defaultSelectionTooltipForecastDeepDiveMulti != null && result[0].defaultSelectionTooltipForecastDeepDiveMulti.toLowerCase() == 'yes') {
					this.EnableTooltip = true;
				}
				if (result != null && result.length > 0 && result[0].enableDisableTooltipForecastDeepDiveMulti != null && result[0].enableDisableTooltipForecastDeepDiveMulti.toLowerCase() == 'yes') {
					this.ShowTooltip = true;
				}

				if (result != null && result.length > 0 && result[0].enableExportForecastDeepDiveMulti != null && result[0].enableExportForecastDeepDiveMulti.toLowerCase() == 'yes') {
					this.IsExportEnable = true;
				}

				if (result != null && result.length > 0 && result[0].enableBasicFcDeepDive != null && result[0].enableBasicFcDeepDive.toLowerCase() == 'no') {
					this.EnableBasicFcDeepDive = false;
					this.rowSpan = this.rowSpan - 1;
				}

				if (result != null && result.length > 0 && result[0].enableDeepDiveMultiGraph != null && result[0].enableDeepDiveMultiGraph.toLowerCase() == 'yes') {
					this.EnableGraph = true;
				}

				if (result != null && result.length > 0 && result[0].enableNextPreviousForecastDeepDiveMulti != null && result[0].enableNextPreviousForecastDeepDiveMulti.toLowerCase() == 'yes') {
					this.enableNextPrevious = true;
				}

				if (result != null && result[0].displayMinRoundingBelowNumberFc != null) {
					this.DisplayMinRoundingBelowNumberFc = result[0].displayMinRoundingBelowNumberFc;
				}

				if (result != null && result[0].displayMinRoundingPlacesFc != null) {
					this.DisplayMinRoundingPlacesFc = result[0].displayMinRoundingPlacesFc;
				}

				this.loadBookMarkFilter();
			},
			(err) => {
				console.log(err);
			}
		);
	}

	/* Export Forecast Option */
	EnableGraph: boolean = false;

	ForecatObjectTable = [];
	ForecatObjectTableCopy = [];
	ForecatUnChnageObjectTable = [];
	PeriodTable = [];
	ForecatCaptionTable = [];
	ForecastField = [];
	forecastElementAddonsNames: ElementNames[];
	forecastElementBasicNames: ElementNames[];
	rowSpan = 4;
	isSaleColumnExists = false;
	//Key Figure For updating ForecastKeyFigure4IncludeDeepDiveMulti
	ForecastKeyFigures = [
		{ FieldName: 'ForecastKeyFigure1IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure1', ColumnName: 'forecastKeyFigure1', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure2IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure2', ColumnName: 'forecastKeyFigure2', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure3IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure3', ColumnName: 'forecastKeyFigure3', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure4IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure4', ColumnName: 'forecastKeyFigure4', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure5IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure5', ColumnName: 'forecastKeyFigure5', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure6IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure6', ColumnName: 'forecastKeyFigure6', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure7IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure7', ColumnName: 'forecastKeyFigure7', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure8IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure8', ColumnName: 'forecastKeyFigure8', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure9IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure9', ColumnName: 'forecastKeyFigure9', Visible: false, Editable: false },
		{ FieldName: 'ForecastKeyFigure10IncludeDeepDiveMulti', Caption: 'ForecastKeyFigure10', ColumnName: 'forecastKeyFigure10', Visible: false, Editable: false },
	];
	settingValue: SettingValue[];
	MultipleFactor: number = 1;
	periodName: string = '';
	deepDiveAdjustMultipleFactorTitle: string = '';
	RoundOffNumber = 0;
	isFirstLoad = true;

	loadedTableDataPrev = null;
	loadTableData(action: string) {
		console.log('started');
		console.log(new Date().toString());

		if (this.StopScrolling) {
			AppDevNotifyComponent.SuccesMessage('You have reach end of search. ');

		} else {
			let dataObjectPram: ForecastDeepDiveMultiPram = new ForecastDeepDiveMultiPram();
			dataObjectPram.Action = action;
			dataObjectPram.PageNumber = this.PageNo;
			dataObjectPram.RowsOfPage = this.PageSize;
			dataObjectPram.filtersOptions = [];
			dataObjectPram.MultipleFactor = this.MultipleFactor;



			if (action == 'loadNextPreOption') {

				if (this.nxtPreFilterOptions != null && this.nxtPreFilterOptions.filters != null && this.nxtPreFilterOptions.filters.length > 0) {
					this.nxtPreFilterOptions.filters.forEach((selElemnt) => {
						dataObjectPram.filtersOptions.push({
							settingId: selElemnt.settingId,
							fieldValue: selElemnt.fieldValue,
						});
					});
				}
			} else {
				this.filterOptions.filters.forEach((element) => {
					dataObjectPram.filtersOptions.push(element);
				});
			}
			dataObjectPram.OrderField = 0;
			dataObjectPram.OrderSeq = 1;
			if (this.ForecatCaptionTable && this.ForecatCaptionTable.length > 0 && this.ForecatCaptionTable.find((x) => x.Ordering == 1) != null) {
				let sitem = this.ForecatCaptionTable.find((x) => x.Ordering == 1);
				dataObjectPram.OrderField = sitem.orderBy + 1;
				dataObjectPram.OrderSeq = sitem.AscDsend;
			}

			this.forecastService
				.SelectForecastDeepDiveTableMultiData(dataObjectPram)
				.toPromise()
				.then((data) => {
					this.processTableData(data, 'pageload');
				})
				.catch((err) => {
					this.IsInfinitScrollDisabled = false;
				});
		}
	}

	public processTableData(data, action) {
		if (data) {
			if (this.isFirstLoad) {
				if (data.fcElemt !== null) {
					let forecastElementNames = data.fcElemt;

					// Basic forecast data.
					if (forecastElementNames !== null && forecastElementNames.length > 0) {
						this.forecastElementBasicNames = forecastElementNames.filter(
							(x) => {
								this.isFirstLoad = false;

								return x.forecastElementType === 'Basic';
							}
						);
					}

					// AddOn data.
					if (forecastElementNames !== null && forecastElementNames.length > 0) {
						this.forecastElementAddonsNames = forecastElementNames.filter(
							(x) => {
								this.isFirstLoad = false;

								return x.forecastElementType === 'AddOn';
							}
						);
					}

					this.rowSpan += data.fcElemt.length;
				}

				if (data.fcObjCap !== null && data.fcObjCap.length > 0) {
					this.ForecatCaptionTable = data.fcObjCap;
					this.ForecatCaptionTable.forEach((item) => {
						item.Ordering = 0;
						if (item.AscDsend == null) {
							item.AscDsend = 1;
						}
					});
				}
				if (data.fcObjAct !== null && data.fcObjAct.length > 0) {
					data.fcObjAct.forEach((element) => {
						element.type = 'left';
						element.action = 'read';
						this.isSaleColumnExists = true;
						this.ForecastField.push(element);
					});
					this.rowSpan += data.fcObjAct.length;
				}

				// Key figure changes for update fields.
				this.settingValue = data.settings;
				if (this.settingValue && this.settingValue.length > 0) {
					this.settingValue.forEach(
						(element) => {
							let keyfigreChnge = this.ForecastKeyFigures.find((x) => x.FieldName.toLowerCase() == element.name.toLowerCase());
							if (element.value.toLowerCase().trim() == 'yes' && keyfigreChnge != null && keyfigreChnge != undefined) {
								keyfigreChnge.Visible = true;
								this.rowSpan += 1;
							}

							let keyfigreCaption = this.ForecastKeyFigures.find((x) => x.ColumnName.toLowerCase() == element.name.toLowerCase());
							if (keyfigreCaption != null && keyfigreCaption != undefined) {
								keyfigreCaption.Caption = element.value;
							}

							let keyfigreEditable = this.ForecastKeyFigures.find((x) => 'editable' + x.ColumnName.toLowerCase() == element.name.toLowerCase());
							if (element.value.toLowerCase().trim() == 'yes' && keyfigreEditable != null && keyfigreEditable != undefined) {
								keyfigreEditable.Editable = true;
							}
						}
					);
				}

				if (data.info !== null && data.info.length > 0) {
					this.MultipleFactor = data.info[0].multipleFactor;
					this.PageSize = data.info[0].rowsOfPage;
					this.periodName = data.info[0].periodName;
					this.deepDiveAdjustMultipleFactorTitle = data.info[0].deepDiveAdjustMultipleFactorTitle;
					this.RoundOffNumber = data.info[0].roundOff;
				}
			}

			if (action === 'pageload') {
				if (data.period && data.period.length > 0) {
					this.PeriodTable = data.period;
				}
			}

			if (data.fcObjData && data.fcObjData.length > 0) {
				data.fcObjData.forEach(
					(element) => {
						element.fcData = [];
						if (data.fc && this.PeriodTable && this.PeriodTable.length > 0) {
							this.PeriodTable.forEach(
								(period) => {
									let dataExists = data.fc.filter((x) => x.forecastObjectId == element.forecastObjectId && x.period == period.period);
									if (dataExists && dataExists.length > 0) {
										element.fcData.push(dataExists[0]);
									} else {
										let defaultValuesNewValue = JSON.parse(JSON.stringify(this.defaultValues));
										defaultValuesNewValue.period = period.period;
										defaultValuesNewValue.forecastObjectId = element.forecastObjectId;
										element.fcData.push(defaultValuesNewValue);
									}
								}
							);
						}

						this.ForecatObjectTable.push(element);
						this.ForecatUnChnageObjectTable.push(JSON.parse(JSON.stringify(element)));
					}
				);
			}

			for (let i = 0; i < this.ForecatObjectTable.length; i++) {
				this.OnFcAjstBasicChangeAll(this.ForecatObjectTable[i].fcData, () => { }, 'onContentReady');
			}

			if (Object.keys(data.fcObjData).length != this.PageSize) {
				this.StopScrolling = true;
			}
		}

		this.isFirstLoad = false;

		this.onResize('dataloadTable');
		this.IsInfinitScrollDisabled = false;

		this.tooManyObjectsPopupVisible = false;

		this.dataFullyLoaded = true;
	}

	tooManyObjectsPopupVisible = false;
	public hideManyObjectsPopup() {
		this.tooManyObjectsPopupVisible = false;
	}

	formatCurrcy = function (values) {
		if (values != null && values != undefined) {
			if (this.DisplayMinRoundingBelowNumberFc > values) {
				return UtilsService.FormatNumberWithDecimalPlacesNew(values, this.DisplayMinRoundingPlacesFc);
			}
			return UtilsService.FormatNumberWithDecimalPlaces(values, this.RoundOffNumber);
		}
		return values;
	};

	ForecastKeyFiguresFilter() {
		return this.ForecastKeyFigures.filter((x) => x.Visible == true);
	}

	popupVisible = false;
	currentComment: any = { Period: 0, Comment: '', forecastObjectId: 0 };
	curentusername: string = '';
	// lastUpdatedAt: Date;
	showInfo(item) {
		this.popupVisible = true;
		this.currentComment.Comment = item.elemntComment;
		this.currentComment.Period = item.period;
		this.currentComment.forecastObjectId = item.forecastObjectId;
		this.curentusername = null;
		if (item.entryUser != null && item.entryUser != undefined) {
			this.curentusername = item.entryUser;
		}


	}

	UpdateForecastCommentInfo(action) {
		this.popupVisible = false;
		if (action == 'Save' && this.ForecatObjectTable != null) {
			let IsDataExists = this.ForecatObjectTable.find((x) => x.forecastObjectId == this.currentComment.forecastObjectId);
			if (IsDataExists != null && IsDataExists.fcData != null && IsDataExists.fcData.length > 0) {
				IsDataExists.fcData.filter((x) => {
					if (x.period == this.currentComment.Period) {
						x.elemntComment = this.currentComment.Comment;
					}
					return x;
				});
			}
		}
		this.currentComment.Comment = '';
		this.currentComment.Period = 0;
		this.currentComment.forecastObjectId = 0;
	}

	private removeThousandSeparator = (number) => number.toString().replace(/,(?=\d{3})/g, '');

	OnFcAjstBasicChangeAll = function (MainLoopItemCollection, e, action) {
		MainLoopItemCollection.forEach((MainLoopItem) => {
			let $this = this;
			let Data: number = MainLoopItem.basic1;
			MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
			$this.forecastElementBasicNames.forEach((element) => {
				if (element.includeInFinalForecast3) {
					if (element != null && MainLoopItem[element.forecastElementFieldName] != null) {
						Data = +this.removeThousandSeparator(MainLoopItem[element.forecastElementFieldName]);
					}
					MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
				}
			});
			$this.SumTotalForecaste(MainLoopItem, e, action);
		});
	};

	OnFcAjstBasicChangeSingle = function (MainLoopItem, e, action) {
		let $this = this;
		let Data: number = MainLoopItem.basic1;
		MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		$this.forecastElementBasicNames.forEach((element) => {
			if (element.includeInFinalForecast3) {
				if (element != null && MainLoopItem[element.forecastElementFieldName] != null) {
					Data = +this.removeThousandSeparator(MainLoopItem[element.forecastElementFieldName]);
					MainLoopItem.touched = true;
				}
				MainLoopItem.fcAjstBasicSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(Data, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
			}
		});
		$this.SumTotalForecaste(MainLoopItem, e, action);
	};

	SumTotalForecaste = function (MainLoopItem, e, action) {
		let $this = this;
		MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.basic1, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		if (isNaN(MainLoopItem.fcTotalSum)) {
			MainLoopItem.fcTotalSum = 0;
		}
		MainLoopItem.fcAjstBasicSum = parseFloat(MainLoopItem.fcAjstBasicSum);
		if (isNaN(MainLoopItem.fcAjstBasicSum)) {
			MainLoopItem.fcAjstBasicSum = 0;
		}

		if (MainLoopItem.fcAjstBasicSum != null) {
			MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcAjstBasicSum, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
		}

		$this.forecastElementAddonsNames.forEach((element) => {
			if (element != null && MainLoopItem[element.forecastElementFieldName] != null && element.includeInFinalForecast3) {
				MainLoopItem.fcTotalSum += UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(+this.removeThousandSeparator(MainLoopItem[element.forecastElementFieldName]), $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);
			}
		});

		MainLoopItem.fcTotalSum = UtilsService.FormatNewNumberWithDecimalPlacesWithoutCurrecyFormat(MainLoopItem.fcTotalSum, $this.RoundOffNumber, $this.DisplayMinRoundingBelowNumberFc, $this.DisplayMinRoundingPlacesFc);

		if (action == 'onContentReady' && $this.ForecatObjectTable != undefined) {
			$this.ForecatObjectTableCopy = JSON.parse(JSON.stringify($this.ForecatObjectTable));
		}
		if (action == 'onChange') {
			MainLoopItem.touched = true;
			//console.log(MainLoopItem, e, action);
		}

		if ($this.activeService != undefined) {
			$this.activeService.setForecastDeepDive($this.CheckContainChanges());
		}
	};

	UploadForestElemt: ForecastElementUpdateMultiData;

	UploadChanges() {
		this.UploadForestElemt = new ForecastElementUpdateMultiData();
		this.UploadForestElemt.action = 'NormalUpdateWithComment';
		this.UploadForestElemt.forecastData = [];
		this.UploadForestElemt.KeyFigureData = [];
		this.UploadForestElemt.KeyFigureFields = [];
		let IsNegativeForecast = false;
		if (this.ForecatObjectTable != null) {
			for (let fcOItem of this.ForecatObjectTable) {
				if (fcOItem.fcData != null && fcOItem.fcData.length) {
					for (let dataItem of fcOItem.fcData) {
						if (dataItem.touched) {
							this.UploadForestElemt.forecastData.push({
								period: dataItem.period,
								entryUser: '',
								ElemntComment: dataItem.elemntComment,
								basic1: dataItem.basic1,
								basic2: dataItem.basic2,
								basic3: dataItem.basic3,
								addOn1: dataItem.addOn1,
								addOn2: dataItem.addOn2,
								addOn3: dataItem.addOn3,
								addOn4: dataItem.addOn4,
								addOn5: dataItem.addOn5,
								ForecastObjectId: dataItem.forecastObjectId,
								commercialObjectId: dataItem.commercialObjectId,
							});
							this.UploadForestElemt.KeyFigureData.push({
								KeyFigure1: dataItem.forecastKeyFigure1,
								KeyFigure2: dataItem.forecastKeyFigure2,
								KeyFigure3: dataItem.forecastKeyFigure3,
								KeyFigure4: dataItem.forecastKeyFigure4,
								KeyFigure5: dataItem.forecastKeyFigure5,
								KeyFigure6: dataItem.forecastKeyFigure6,
								KeyFigure7: dataItem.forecastKeyFigure7,
								KeyFigure8: dataItem.forecastKeyFigure8,
								KeyFigure9: dataItem.forecastKeyFigure9,
								KeyFigure10: dataItem.forecastKeyFigure10,
								period: dataItem.period,
								ForecastObjectId: dataItem.forecastObjectId,
								commercialObjectId: dataItem.commercialObjectId,
							});
							if (dataItem.fcTotalSum < 0) {
								IsNegativeForecast = true;
							}
						}
					}
				}
			}
		}

		this.ForecastKeyFigures.forEach((element) => {
			if (element.Visible == true) {
				this.UploadForestElemt.KeyFigureFields.push({ KeyPair: element.ColumnName, ValuePair: element.ColumnName });
			}
		});

		if (IsNegativeForecast) {
			this.proceedingInfoPopup = true;
		} else {
			this.UploadForecastChanges();
		}
	}

	proceedingInfoPopup = false;
	changeProceedingForecastInfoPopupStatus() {
		this.proceedingInfoPopup = false;
	}

	UploadForecastChanges = () => {
		this.proceedingInfoPopup = false;

		this.forecastService.UpdateForecastBasicMultiManualAdjustment(this.UploadForestElemt).subscribe(
			(res) => {

				this.loadGraphData('');
				for (let index = 0; index < res.returnFlag.length; index++) {
					if (res.returnFlag[index].flag > 0) {
						AppDevNotifyComponent.SuccesMessage(res.returnFlag[index].msg);
					} else {
						AppDevNotifyComponent.ErrorMessage(res.returnFlag[index].msg);
					}
				}

				try {
					this.ForecatUnChnageObjectTable.forEach((FoItem) => {
						if (FoItem && FoItem.forecastObjectId && FoItem.fcData) {
							let FoItemNew = this.ForecatObjectTable.find((x) => x.forecastObjectId == FoItem.forecastObjectId);
							if (FoItemNew && FoItemNew.fcData) {
								FoItemNew.fcData.forEach((fcDataNewItem) => {
									let itemFnd = FoItem.fcData.find((x) => x.forecastObjectId == fcDataNewItem.forecastObjectId && x.period == fcDataNewItem.period);

									if (itemFnd.elemntComment != fcDataNewItem.elemntComment || itemFnd.basic2 != fcDataNewItem.basic2 || itemFnd.basic3 != fcDataNewItem.basic3 || itemFnd.addOn1 != fcDataNewItem.addOn1 || itemFnd.addOn2 != fcDataNewItem.addOn2 || itemFnd.addOn3 != fcDataNewItem.addOn3 || itemFnd.addOn4 != fcDataNewItem.addOn4 || itemFnd.addOn5 != fcDataNewItem.addOn5) {
										fcDataNewItem.entryUser = this.authService.currentUserName;
									}
								});
							}
						}
					});
				} catch (e: unknown) { }
			},
			(err) => {
				AppDevNotifyComponent.ErrorMessage('Sorry, something went wrong. Please try after some time again.');

			}
		);
	};

	OnFcAjstBasicFocusIn(e) {
		let inputEl = e.element.querySelector('.dx-texteditor-input');
		inputEl.selectionStart = 0;
		inputEl.selectionEnd = inputEl.value.length;
	}

	//infint scroll
	IsInfinitScrollDisabled: boolean = false;
	selector: string = '.main-panel';
	WindowHeight = '800px';
	PageSize = 4;
	PageNo = 1;
	StopScrolling = false;
	onScroll() {
		this.PageNo += 1;
		this.isFirstDataLoad = false;
		this.loadTableData('reload');
	}

	public onHelpButtonClicked(event, settingName: string) {
		this.helpService.openHelpPage(settingName);
	}
	period: string = '';

	loadScrollBar() {

	}

	currentValueNxtPr: NextPreValue;
	OnResetPreDieldChange(e: string) {
		if (e != null) {
			let filterDataitem = this.filterList.find((x) => x.selectionName == e);
			if (filterDataitem != null && filterDataitem.selectionId != null) {
				filterDataitem.selectedValues = [];
				this.taskFilterData = this.taskFilterData.filter((x) => x.settingId != filterDataitem.selectionId);
				this.filterOptions.filters = this.filterOptions.filters.filter((x) => x.settingId != filterDataitem.selectionId);
			}
		}
	}


	onNextPrevConfirm = (): boolean => {
		if (!this.CheckContainChanges() && !confirm(this.activeService.getConfirmMessage())) {
			return false
		} else {
			return true
		}
	}

	OnNextPreChange(e: NextPreValue) {
		this.currentValueNxtPr = e;
		if (!Number.isNaN(Number(e.selectionId))) {
			this.StopScrolling = false;
			this.IsInfinitScrollDisabled = true;
			this.PageNo = 1;
			this.ForecatUnChnageObjectTable = [];
			this.ForecatObjectTable = [];
			this.clearSelectedItem();
			this.StopScrolling = false;
			//default load with parameters
			this.nxtPreFilterOptions = new FiltersOutput();
			this.nxtPreFilterOptions.action = this.Action;
			this.nxtPreFilterOptions.settingGroupId = this.settingGroupId;
			this.nxtPreFilterOptions.filters = [];

			//loading filter data
			if (this.taskFilterData == undefined) {
				this.taskFilterData = [];
			}
			this.taskFilterData = this.taskFilterData.filter((x) => x.settingId !== Number(e.selectionId));
			this.filterOptions.filters = this.filterOptions.filters.filter((x) => x.settingId !== Number(e.selectionId));
			this.taskFilterData.push({ settingId: Number(e.selectionId), settingValue: e.currentValue, fieldName: e.columnName });
			this.filterList.forEach((fcItem) => {
				if (fcItem.selectionId === Number(e.selectionId)) {
					fcItem.selectedValues = [];
				}
			});
			if (this.filterList != null) {
				this.filterList.forEach((element) => {
					if (element != null && element.selectedValues != null && element.selectedValues.length > 0 && Number(e.selectionId) != element.selectionId) {
						element.selectedValues.forEach((elementSelct) => {
							let filteItemSel: FilterOutput = new FilterOutput();
							filteItemSel.fieldValue = elementSelct;
							filteItemSel.settingId = Number(element.selectionId);
							this.nxtPreFilterOptions.filters.push(filteItemSel);
						});
					}
				});
			}

			let filteItem: FilterOutput = new FilterOutput();
			filteItem.fieldValue = e.currentValue;
			filteItem.settingId = Number(e.selectionId);
			this.nxtPreFilterOptions.filters.push(filteItem);
			this.IsTaskLoad = true;
			this.getFiltersData();
			this.getData('loadNextPreOption');

		}
	}

	OpenDeepDive(item) {
		window.open('forecast/deep-dive-new?id=' + UtilsService.getURLHelper(item.linkDeepDiveClientId), '_blank');
	}

	CheckContainChanges(): boolean {
		// console.log('Checking changes...', JSON.stringify(this.ForecatObjectTable), JSON.stringify(this.ForecatObjectTableCopy));
		return JSON.stringify(this.ForecatObjectTable) == JSON.stringify(this.ForecatObjectTableCopy);
	}

	defaultSorting = '';
	OrderBy(item) {
		this.ForecatCaptionTable.forEach((item) => {
			item.Ordering = 0;
		});
		item.Ordering = 1;
		if (item.AscDsend == 1) {
			item.AscDsend = 0;
		} else {
			item.AscDsend = 1;
		}
		this.PageNo = 1;
		this.StopScrolling = false;
		this.ForecatUnChnageObjectTable = [];
		this.ForecatObjectTable = [];
		this.loadTableData('reload');
	}

	checkif() {
		let istrue = true;
		this.ForecatCaptionTable.forEach((item) => {
			if (istrue == true) {
				if (item.Ordering == 0 || item.Ordering == null) {
					istrue = true;
				} else {
					istrue = false;
				}
			}
		});
		return istrue;
	}
}
